<div #content>
  <div>
    <div *ngFor="let b of blankBarcodes" class="barcode-container">
      <media-barcode
        [media]="null"
        style="
          justify-content: center;
          display: flex;
          overflow: visible;
          box-sizing: border-box;
        "
      ></media-barcode>
    </div>
    <div *ngFor="let m of Medias" class="barcode-container">
      <media-barcode
        [media]="m"
        style="
          justify-content: center;
          display: flex;
          overflow: visible;
          box-sizing: border-box;
        "
      ></media-barcode>
      <media-signature
        *ngIf="UseMediaSignature"
        [media]="m"
        style="
          justify-content: center;
          display: flex;
          overflow: visible;
          box-sizing: border-box;
        "
        [style.background-color]="
          signatureColorRectangle ? null : m.mediaClass.color
        "
      ></media-signature>
    </div>
  </div>
</div>
